<template>
  <footer class="bg-white py-6 shadow-inner mt-12">
    <div class="container mx-auto px-4">
      
      
      <!-- <div class="flex flex-col md:flex-row justify-between items-center">
        <div class="mb-4 md:mb-0">
          <p class="text-gray-600">&copy; {{ new Date().getFullYear() }} PDF转DOCX工具. 保留所有权利.</p>
        </div>
        <div class="flex space-x-4">
          <a href="#" class="text-gray-600 hover:text-blue-600">关于我们</a>
          <a href="#" class="text-gray-600 hover:text-blue-600">使用条款</a>
          <a href="#" class="text-gray-600 hover:text-blue-600">隐私政策</a>
          <a href="#" class="text-gray-600 hover:text-blue-600">联系我们</a>
        </div>
      </div> -->

      <div class="flex flex-col justify-center items-center">
  <div class="mb-4 md:mb-0 text-center">
    <p class="text-gray-600">©2025 PDF转DOCX工具 | 让转换更简单，生活更轻松</p>
  </div>
  <div class="flex space-x-4">
          <a href="/tutorial"  target="_blank"  class="text-gray-600 hover:text-blue-600">使用教程</a>
          <a href="/faq" target="_blank" class="text-gray-600 hover:text-blue-600">常见问题</a>
          <!-- <a href="#" class="text-gray-600 hover:text-blue-600">隐私政策</a>
          <a href="#" class="text-gray-600 hover:text-blue-600">联系我们</a> -->
   </div>

</div>
    </div>
  </footer>
</template>